(() => {
function init(scope=document){
 scope.querySelectorAll('[data-nav-target]').forEach(el=>{
  if(el.dataset.navReady)return;el.dataset.navReady='true';
  el.setAttribute('role','link');el.tabIndex=0;el.style.cursor='pointer';
  const go=()=>{const target=document.querySelector(el.dataset.navTarget);if(target){target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}document.getElementById('el-361956')?.hidePopover?.();};
  el.addEventListener('click',go);el.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();go();}});
 });
 scope.querySelectorAll('[popover-target]').forEach(el=>{
  if(el.dataset.menuReady)return;el.dataset.menuReady='true';
  el.setAttribute('role','button');el.setAttribute('aria-label','Toggle navigation');el.setAttribute('aria-expanded','false');el.tabIndex=0;
  const menu=document.getElementById(el.getAttribute('popover-target'));el.setAttribute('aria-controls',menu?.id||'');
  menu?.addEventListener('toggle',e=>el.setAttribute('aria-expanded',String(e.newState==='open')));
  const toggle=()=>menu?.togglePopover?.();el.addEventListener('click',toggle);el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
 });
 const form=scope.querySelector('#svc-book');
 if(form&&!form.dataset.formReady){
  form.dataset.formReady='true';
  const status=form.querySelector('#svc-status');const button=form.querySelector('button');
  form.addEventListener('submit',e=>{
   button.dataset.originalText=button.textContent;button.disabled=true;button.setAttribute('aria-busy','true');
   if(status)status.textContent=form.dataset.sending||'Sending your request…';
  });
 }
}
init();document.addEventListener('shopify:section:load',e=>init(e.target));
window.addEventListener('pageshow',()=>{document.querySelectorAll('.svc-submit').forEach(button=>{button.disabled=false;button.removeAttribute('aria-busy');});});
})();
